<template>
  <base-section id="theme-features">
    <base-section-heading 
      color="grey lighten-2"
      icon="mdi-spider-thread"
      title="타란툴라 주요특징"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <div v-if="i===0">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              단 한줄의 코딩없이 Native SQL 만으로, 이기종 데이터베이스간의 데이터 실시간 조회 및 조인이 가능합니다. 
              물론 단순 조회 뿐 아니라 이기종 데이터베이스간의 DML도 가능합니다.
            </base-avatar-card>
          </div>

          <div v-if="i===1">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              RDBMS 뿐만 아니라 몽고디비와 같은 NOSQL 과도 데이터 조회및 머지가 가능합니다.
              현재 타란툴라와 연계 가능한 DB 아래를 참조해주세요.
            </base-avatar-card>
          </div>

          <div v-if="i===2">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              MSA (MicroService Architecture)에 적합한 솔루션입니다 (HTTP 프로토콜로 데이터베이스 통신). 각 서비스 특성에 최적화된 멀티 데이터베이스를 이용하는 개발 환경에서 타란툴라를 도입시,
              개발 시간을 대폭 단축 시켜줄 뿐 아니라, 분산 트랙잭션까지 가능합니다. 또한 굳이 MSA 가 아니더라도 이기종 데이터베이스를 사용하는 개발환경에서는 필수 솔루션입니다.
            </base-avatar-card>
          </div>

          <div v-if="i===3">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              타란툴라는 일종의 미들웨어 제품입니다. 기존의 레거시 데이터베이스를 타란툴라와 연동하면, DB 데이터를 HTTP(json-rpc 2.0) 프로토콜을 통해 즉각적으로 액세스 할수 있습니다.
              기존의 데이터베이스 앞단에 타란툴라를 설치하여 연동하는 즉시, 이 모든게 단 한줄의 프로그래밍 없이 SQL 작성만으로 바로 가능해 집니다.
            </base-avatar-card>
          </div>


          <div v-if="i===4">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              타란툴라를 통한 레거시 데이터베이스의 데이터 조회시, 자주 변경이 되지 않는 데이터라면 타란툴라 내부의 캐싱 기능을 이용해서 레거시 데이터베이스로의 접속없이 바로 데이터 리턴이 가능합니다.
              타란툴라를 레거시 데이터베이스의 "캐싱 데이터베이스 서버" 로 활용할수 있습니다.
            </base-avatar-card>
          </div>


          <div v-if="i===5">
            <base-avatar-card
              v-bind="feature"
              align="left"
              horizontal
            >
              "타란툴라"는 도커(Docker) 컨테이너(Container) 기술을 적용하여 온프레미스(on-premise)나 클라우드(cloud) 환경에 상관없이 편리한 설치가 가능합니다. 또한 쿠버네티스(Kubernetes) 환경도 지원합니다.
            </base-avatar-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: '멀티 데이터베이스 실시간 조회',
          icon: 'mdi-database-search',
        },
        {
          title: 'RDBMS/NOSQL 데이터 조합',
          icon: 'mdi-text-box-multiple',
        },
        {
          // color: 'primary',
          // dark: true, 
          title: '마이크로서비스 아키텍처(MSA) 솔루션',
          icon: 'mdi-atom',
        },
        {
          title: '손쉬운 Open APi 서비스 구축',
          icon: 'mdi-web',
        },
        {
          title: '강력한 캐싱 기능',
          icon: 'mdi-cached',
        },
        {
          title: '수평적 성능 확장',
          icon: 'mdi-docker',
        },
      ],
    }),
  }
</script>
